import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MenuItem, SelectItemGroup } from 'primeng/api';
import { catchError, combineLatest, of } from 'rxjs';
import { ParkingService } from '../services/parking.service';
import { MapsComponent } from '../maps/maps.component';
import { LocationInput } from '@core/models/edit-parking-request.model';
import {
  Invalid_IMAGE_FORMAT,
  MSG_DELETE_VEHICLE,
  MSG_UPDATE_PARKING,
  UNDER_MAINTANCE_ERROR,
  UNDER_MAINTANCE_GREATERTIME,
  USER_ROLES,
} from '@shared/constant/shared.constant';
import { ParkingLotDetail } from '@core/models/parking-detail.model';
import { ParkingLotSlotsResponse } from '@core/models/parking-slot.model';
import { VehicleTypeDetail } from '@core/models/vehicle-type-detail.model';
import { FacilityDetail } from '@core/models/facility-detail.model';
import * as _ from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import {
  CreateComingSoonParking,
  SpecialRate,
} from '@core/models/create-parking-request.model';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import { ToastService } from '@shared/services/toast.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { validateInput, CustomValidator } from '@shared/services/custom-validatior.abstract';
import {
  BreadcrumbItem,
  CompanyService,
} from '@shared/services/company.service';
import { CommonFunctions } from '@shared/common-functions';
import { CustomRatesPopupComponent } from '../custom-rates-popup/custom-rates-popup.component';
import { CommonMenuService } from '@shared/services/common-util.service';
import { Editor } from 'primeng/editor';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
@Component({
  selector: 'app-edit-parking',
  templateUrl: './edit-parking.component.html',
  styleUrls: ['./edit-parking.component.scss'],
})
export class EditParkingComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  checked: boolean = false;
  minDate: Date = new Date();
  truckTypes: VehicleTypeDetail[] = [];
  trucknames: string[] = [];
  parkingLotFacility: any[] = [];
  selectedOptions: any[] = [];
  noOptionsAvailable: boolean = false;
  slotsAvailable: any;
  allowedExtensions = ['jpg', 'jpeg', 'png'];
  count: number = 1;
  buttonDisabled: boolean = false;
  facilitiesList: FacilityDetail[] = [];
  parkingForm!: FormGroup;
  parkingUpcomingForm!: FormGroup;
  isImgError1: boolean = false;
  isImgError2: boolean = false;
  isImgError3: boolean = false;
  images: any[] = [];
  imageUrl2: string = '';
  imageUrl3: string = '';
  imageUrl1: any = [];
  btn1: boolean = false;
  btn2: boolean = false;
  btn3: boolean = false;
  totalNumberOfSlots: number;
  totalTruckCategory = 0;
  id: string = '';
  maintenanceslots: any[] = [];
  selectedSlots: any[] = [];
  vehicleNamesArray: any[][] = [];
  vehicleNames: string[] = [];
  imagePreview: boolean = false;
  imageLinkForPreview: string;
  visible: boolean = false;
  isEntireParkingNotAvaliable: boolean = false;
  isUnderMaintenance: boolean = true;
  getHoursValue: { label: string; value: number }[] = [];
  noSlotSelected = true;
  isActive: boolean;
  isParkAnywhere: boolean;
  isParkingCapacityError: boolean = false;
  selectedFacilities: string[] = [];
  firstArray: VehicleTypeDetail[] = [];
  secondArray: VehicleTypeDetail[] = [];
  disableForm: boolean = false;
  isComingsoonParking: boolean = false;
  comingSoon: boolean;
  roleName: string;
  formData: FormData = new FormData();
  groupedVehicles: SelectItemGroup[];
  specialRates: any[] = [];
  spotTypes = [];
  activeItem: any;
  items: MenuItem[];
  uploadedFile: string  | null = null;
  EquipmentMessage: any = `<div class="half-length"><p><b>Half-Length Spot (12x40 ft):</b> This category is designed for smaller trucks, vans, and trailers that require less space. Typically, these spots accommodate vehicles that are up to 40 feet in length. These spots are most suitable for compact or medium-sized trucks that don’t need the extended space of a full-length spot.</p></div>
<div class="half-length full-length"><p><b>Full-Length Spot (12x75 ft):</b> This category is designed for larger trucks and trailers, providing ample space for vehicles that are up to 75 feet long. These spots provide the necessary room for heavy-duty vehicles that require more space for parking, loading, or unloading.</p></div>`;
  ckEditorConfig: any = {
    toolbar: [
      [
        'Format',
        'Templates',
        'Bold',
        'Italic',
        'Underline',
        '-',
        'CopyFormatting',
        'RemoveFormat',
        'NumberedList',
        'BulletedList',
      ],
    ],
  };
  entireParkingMaintanceList = [
    { name: 'Yes', value: '1' },
    { name: 'No', value: '0' },
  ];
  currentspace: boolean = true;
  parkingLotDetail: any;
  commingSoonCheckbox: boolean = false;
  @ViewChild('fileUpload') fileUpload: any;
  @ViewChild('fileUpload1') fileUpload1: any;
  @ViewChild('fileUpload2') fileUpload2: any;
  optionalValidation: boolean = false;
  companyId: string;
  userRoles = USER_ROLES;
  editorInstance: any; // Store Quill instance
  editorRecurringInstance: any;
  termsAndConditionFilePath: any;
  maxLength = 1000;
  textLength: { [key: string]: number } = {} 
  isFileUploaded: boolean = false;
  oneTimeEditorText: string;
  recurringEditorText: string;
  oneTimeEditorSpaceError: boolean = false;
  oneTimeEditorTextLimitError: boolean = false;
  recurringEditorSpaceError: boolean = false;
  recurringEditorTextLimitError: boolean = false;
  editorTools = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link'], // removed 'image', 'video', etc.
      ['clean'] // clear formatting
    ]
  };

  constructor(
    private readonly router: Router,
    private readonly dialogControlService: DialogControlService,
    private readonly parkingService: ParkingService,
    private readonly confirmationService: ConfirmationService,
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly toastService: ToastService,
    private readonly companyService: CompanyService,
    private readonly cdr: ChangeDetectorRef,
    private readonly commonMenuService: CommonMenuService,
    private readonly encryptStorage: EncryptionStorageService
  ) { }

  ngOnInit() {
    this.roleName = this.encryptStorage.getItem('roleName');
    this.companyId = this.encryptStorage.getItem('companyId');
    const rolePath = this.roleName === USER_ROLES.SUPER_ADMIN ? 'super-admin' : 'manager';
    const breadcrumbObj: BreadcrumbItem[] = [
      {
        title: 'Parking Locations',
        url: `${rolePath}/parking-list/${this.companyId}`,
      },
      {
        title: 'Edit Parking',
      },
    ];
    this.companyService.setAdminHeaders('0', breadcrumbObj);
    
    this.route.params.subscribe((params) => {
      this.id = params['id'];
      this.getParkingLotSpecialRateById();
      this.buildForm();
      if (this.id) {
        this.bindAllData();
      }
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (!this.isValidFileType(file)) {
        this.toastService.showToastMessage('error', 'Error', 'Only PDF and DOCX files are allowed.');
        return;
      }
      if (file.size > 5 * 1024 * 1024) { // Check if file size is more than 5 MB
        this.toastService.showToastMessage('error', 'Error', 'File size should not exceed 5 MB.');
        return;
      }
      this.uploadedFile = 'Parking Location Terms & Conditions'; // Always show this text
      this.formData.append('Images', file); // Append the file to FormData
      this.documentUpload();
    }
  }

  documentUpload() {
    
    this.parkingService.imageUplaod(this.formData)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe((response) => {
        if (response) {
          const data = response;
          for (const key in data) {
            if (data.hasOwnProperty(key)) {
              const url = data[key];
              this.parkingForm.get('termsAndConditionFilePath')?.setValue(url);
              this.termsAndConditionFilePath = url;
              this.isFileUploaded = true;
              this.updateRecurringInstructionsValidator();
              
            }
          }
        }
      });
  }

  isValidFileType(file: File): boolean {
    const allowedTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    return allowedTypes.includes(file.type);
  }

  removeFile(fileInput: HTMLInputElement): void {
    this.uploadedFile = null;
    this.termsAndConditionFilePath = null;
    this.isFileUploaded = false;
    this.formData.delete('Images');
    this.parkingForm.get('termsAndConditionFilePath')?.setValue(null);
    this.updateRecurringInstructionsValidator();
    // Reset the file input
    fileInput.value = ''; // Reset the file input
  }

  onEditorInit(event: any) {
    this.editorInstance = event.editor;
  }
  onRecurringInit(event: any) {
    this.editorRecurringInstance = event.editor;
  }

  getPlainText(html: string): string {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }

  preventSpaces(event: KeyboardEvent) {
    CommonFunctions.preventSpaces(event);
  }

  preventFirstSpace(event: KeyboardEvent) {
    CommonFunctions.preventFirstSpaces(event);
  }

  updateRecurringInstructionsValidator() {
    const recurringInstructionsControl = this.parkingForm.get('recurringInstructions');
    if (this.isFileUploaded) {
      // If a file is uploaded, remove the required validator
      recurringInstructionsControl?.clearValidators();
    } else {
      // If no file is uploaded, set the required validator
      recurringInstructionsControl?.setValidators([Validators.required]);
    }
    recurringInstructionsControl?.updateValueAndValidity(); // Update the control's validity
  }

  bindAllData(): void {
    
    combineLatest([
      this.parkingService.getVehicleTypeList().pipe(catchError(() => of(null))),
      this.parkingService
        .getparkingDetailById(this.id)
        .pipe(catchError(() => of(null))),
    ])
      .pipe(
       autoUnsubWith(this.destroyRef))
      .subscribe({
        next: ([_vehicleData, _parkingLotData]: [
          VehicleTypeDetail[],
          ParkingLotDetail
        ]) => {
          if (_vehicleData) {
            this.truckTypes = _vehicleData;
            this.groupedVehicles = CommonFunctions.groupVehicleTypes(
              this.truckTypes
            );
            this.trucknames = _vehicleData.map((x) => {
              return x.name;
            });
          }
          if (_parkingLotData) {
            this.parkingLotDetail = _parkingLotData;
            combineLatest([
              this.parkingService
                .getParkingLotDetailsWithSlots(this.id)
                .pipe(catchError(() => of(null))),
              this.parkingService
                .getFacilityList()
                .pipe(autoUnsubWith(this.destroyRef), catchError(() => of(null))),
            ]).subscribe({
              next: ([_slot, _facilityData]: [
                ParkingLotSlotsResponse,
                FacilityDetail[]
              ]) => {
                if (_slot) {
                  this.slotsAvailable = _slot.parkingLotSlotsOutput[0].slots;
                  this.maintenanceslots = _slot.slotsUnderMaintenance;
                  this.maintenanceslots.forEach((slot) => {
                    if (slot.isMaintenance) {
                      this.selectedSlots.push(slot);
                    }
                  });
                }
                if (_facilityData) {
                  this.facilitiesList = _facilityData;
                }
                if (_parkingLotData) {
                  const convertedDateTime = CommonFunctions.convertTimeBetweenZones(_parkingLotData.timeZone, new Date());
                  this.generateHourOptions(convertedDateTime);
                  this.minDate = new Date(convertedDateTime);
                  this.comingSoon = _parkingLotData.isComingSoon;
                  this.spotTypes = _parkingLotData.truckType;
                  this.addNewTruckType(_parkingLotData.truckType);
                  if (!_parkingLotData.isComingSoon) {
                    const currentDate = new Date();
                    const databaseDateString =
                      _parkingLotData.parkingLotMaintenanceEndDate;

                    if (currentDate.toISOString() > databaseDateString) {
                      this.currentspace = true;
                    } else {
                      this.currentspace = false;
                    }
                    this.disableForm = _parkingLotData.isHazardousLoad ?? false;
                    this.totalNumberOfSlots =
                      _parkingLotData.totalNumberOfSlots;
                    this.isParkAnywhere = _parkingLotData.isParkAnywhere;
                    this.isActive = _parkingLotData.isActive;
                    const isEntireParkingUnderMaintenance =
                      _parkingLotData.isEntireParkingUnderMaintenance;
                    const startDateTime =
                      _parkingLotData.parkingLotMaintenanceStartDate == null
                        ? _parkingLotData.parkingLotMaintenanceStartDate
                        : new Date(
                          _parkingLotData.parkingLotMaintenanceStartDate
                        );
                    const endDateTime =
                      _parkingLotData.parkingLotMaintenanceEndDate == null
                        ? _parkingLotData.parkingLotMaintenanceEndDate
                        : new Date(
                          _parkingLotData.parkingLotMaintenanceEndDate
                        );
                    const result = _.groupBy(
                      _parkingLotData.truckTypeForWeb,
                      (item) => item.uniqueNumber
                    );

                    const vehicleTypes = Object.keys(result);
                    vehicleTypes.forEach((uniqueNumber) => {
                      const vehiclesForType = result[uniqueNumber];
                      const vehicleNamesDetails = vehiclesForType.flatMap(
                        (vehicle) => {
                          return vehicle.vehicleType.map((type) => ({
                            name: type.vehicleName,
                            id: type.vehicleId,
                          }));
                        }
                      );

                      this.vehicleNamesArray.push(
                        vehicleNamesDetails.map((item) => item.id)
                      );
                    });
                    this.parkingForm.patchValue({
                      name: _parkingLotData.name,
                      locAddress: _parkingLotData.location.address,
                      location: _parkingLotData.location,
                      hazardousLoadRate:
                        _parkingLotData.hazardousLoadRate > 0
                          ? _parkingLotData.hazardousLoadRate
                          : '',
                      isHazardousLoad: _parkingLotData.isHazardousLoad ?? false,
                      offer:
                        _parkingLotData.offer > 0 ? _parkingLotData.offer : '',
                      oneTimeInstructions: _parkingLotData.termsAndCondition,
                      recurringInstructions: _parkingLotData.termsAndConditionRecurring,
                      oneTimeAccessCode: _parkingLotData.accessCode,
                      monthlyAccessCode: _parkingLotData.monthlyAccessCode,
                      termsAndConditionFilePath: _parkingLotData.termsAndConditionFilePath,
                      taxAndFees:
                        _parkingLotData.taxAndFees > 0
                          ? _parkingLotData.taxAndFees
                          : '',
                      truckType: _parkingLotData.truckTypeForWeb,
                      totalSlots: _parkingLotData.totalNumberOfSlots,
                      thresholdValue: _parkingLotData.thresholdValue,
                      isParkAnywhere: _parkingLotData.isParkAnywhere,
                      parkingLayoutImg: _parkingLotData.parkingLotLayout ?? '',
                      startDate: startDateTime,
                      startTime: startDateTime ===  null ? null : this.extractHourFromISOString(startDateTime),
                      endDate: endDateTime,
                      endTime: endDateTime === null ? null : this.extractHourFromISOString(endDateTime),
                      isEntireParkingUnderMaintenance:
                        isEntireParkingUnderMaintenance == true ? '1' : '0',
                      isParkingLotLayoutDoc:
                        _parkingLotData.isParkingLotLayoutDoc,
                      spaceUnderMaintenance:
                        _parkingLotData.spaceUnderMaintenance,
                    });
                    if (_parkingLotData?.termsAndConditionFilePath) {
                      this.termsAndConditionFilePath = this.parkingLotDetail.termsAndConditionFilePath;
                      this.uploadedFile = 'Parking Lot Terms & Conditions';
                      this.isFileUploaded = true;
                    }
                    this.isEntireParkingNotAvaliable =
                      isEntireParkingUnderMaintenance;
                    if (isEntireParkingUnderMaintenance == true) {
                      this.parkingForm.controls[
                        'spaceUnderMaintenance'
                      ].disable();
                    }
                    this.selectedFacilities = [];
                    this.facilitiesList.forEach((facility) => {
                      const selectedFacility =
                        _parkingLotData.parkingLotFacility.some(
                          (item: any) => item.facilityId === facility.id
                        );
                      if (selectedFacility) {
                        this.selectedFacilities.push(facility.facilityName);
                        this.parkingLotFacility.push(facility.id); // Push the checked facility ID into parkingLotFacility array
                      }
                    });
                    this.btn1 = this.btn2 = this.btn3 = false;
                    _parkingLotData.parkingLotImages.forEach(
                      (img: any, index: number) => {
                        if (img.imagePath) {
                          this.images.push(img.imagePath);
                          if (index == 0) {
                            this.imageUrl1 = img.imagePath;
                            this.btn1 = true;
                          } else if (index == 1) {
                            this.imageUrl2 = img.imagePath;
                            this.btn2 = true;
                          } else {
                            this.imageUrl3 = img.imagePath;
                            this.btn3 = true;
                          }
                        }
                      }
                    );
                    if (this.editorInstance) {
                      this.editorInstance.clipboard.dangerouslyPasteHTML(0, _parkingLotData.termsAndCondition);
                        this.oneTimeEditorText = this.getPlainText(_parkingLotData.termsAndCondition) || '';
                      this.textLength['oneTimeInstruction'] = this.oneTimeEditorText.length;
                    }
                    if(this.editorRecurringInstance){
                      this.editorRecurringInstance.clipboard.dangerouslyPasteHTML(0, _parkingLotData.termsAndConditionRecurring);
                      this.recurringEditorText = this.getPlainText(_parkingLotData.termsAndConditionRecurring || '');
                      this.textLength['recurringInstruction'] = this.recurringEditorText.length;
                    }
                  } else {
                    this.isComingsoonParking = true;
                    this.commingSoonCheckbox = true;
                    this.parkingUpcomingForm.patchValue({
                      name: _parkingLotData.name,
                      locAddress: _parkingLotData.location.address,
                      location: _parkingLotData.location,
                    });
                  }
                }
              },
            });
          }
        },
      });
  }

  showData(_rowData: any, event: any) {
    const actionMap = {
      edit: () => {
        this.editSpecialRate(_rowData);
      },
      delete: () => {
        this.deleteSpecialRate(_rowData, event);
      },
    };

    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'Edit',
        icon: 'common-icon custom-editicon',
        escape: false,
        command: actionMap.edit,
      },
      {
        label: 'Delete',
        icon: 'common-icon custom-delete',
        command: actionMap.delete,
      },
    ];

    this.items = this.commonMenuService.commonShowData(config);
  }
  extractHourFromISOString(dateInput: string | Date): number {
    const dateStr = dateInput instanceof Date ? dateInput.toISOString() : dateInput;
    const timePart = dateStr?.split("T")[1];
    if (!timePart) return -1;
    const hourString = timePart.split(":")[0];
    const hour = parseInt(hourString, 10);
    return  hour;
  }
    
  generateHourOptions(startDate: Date): void {
    const currentHour = new Date(startDate).getHours();
    const isPastHour = (i: number) => i < currentHour;
    this.getHoursValue = Array.from({ length: 24 }, (_, i) => ({
      label: this.formatHour(i),
      value: i,
      disabled: isPastHour(i)
    }));
  }
  formatHour(hour: number): string {
    const amPm = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${formattedHour.toString().padStart(2, '0')}:00 ${amPm}`;
  }
  deleteSpecialRate(record: SpecialRate, event): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: MSG_DELETE_VEHICLE,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const index = this.specialRates.findIndex(
          (rate) =>
            rate.code === record.code && rate.spotTypeId === record.spotTypeId
        );
        if (index > -1) {
          this.specialRates.splice(index, 1);
          this.cdr.detectChanges();
        }
      },
    });
  }

  getRatesBySpotTypeId(spotTypeId: string): SpecialRate[] {
    return this.specialRates?.filter((rate) => rate.spotTypeId === spotTypeId);
  }
  isSpecialRateEnabled(spotIndex: number): boolean {
    const truckType = this.truckTypeArray.at(spotIndex);
    const dailyRate = truckType.get('dailyRate')?.value;
    const monthlyRate = truckType.get('monthlyRate')?.value;
    return !(dailyRate && monthlyRate);
  }

  getParkingLotSpecialRateById() {
    this.parkingService.getParkingLotSpecialRateById(this.id)
     .pipe(
        autoUnsubWith(this.destroyRef)
      )
    .subscribe({
      next: (response: any) => {
        this.specialRates = response; 
      }
    });
  }

  editSpecialRate(record: SpecialRate) {
    const editIndex = this.specialRates.indexOf(record);
    const ref = this.dialogControlService.openDialog(
      CustomRatesPopupComponent,
      {
        styleClass: 'custom-rate-main',
        data: {
          SpotTypeId: record.spotTypeId,
          exsistingRecord: record,
          editIndex: editIndex,
        },
      }
    );

    this.dialogControlService.onClose().subscribe((result) => {
      if (result && result.specialRate) {
        const { specialRate, editIndex } = result;

        if (editIndex > -1) {
          this.specialRates.splice(editIndex, 1, ...specialRate);
        } else {
          this.specialRates.push(specialRate);
        }

        this.cdr.detectChanges();
      }
    });
  }

  openCustomRates(id: string): void {
    const truckType = this.truckTypeArray.controls.find(
      (control: any) => control.get('spotTypeId')?.value === id
    );
    const dailyRate = truckType?.get('dailyRate')?.value;
    const monthlyRate = truckType?.get('monthlyRate')?.value;

    const ref = this.dialogControlService.openDialog(
      CustomRatesPopupComponent,
      {
        styleClass: 'custom-rate-main',
        data: {
          SpotTypeId: id,
          dailyRate: dailyRate,
          monthlyRate: monthlyRate,
        },
      }
    );
    this.dialogControlService.onClose().subscribe((result) => {
      if (result?.specialRate && Array.isArray(result.specialRate)) {
        this.specialRates = this.specialRates || []; // Ensure it's initialized
        this.specialRates.push(...result.specialRate);
        this.cdr.detectChanges();
      }   
    });
  }

  createTruckFormGroup(truck: any): FormGroup {
    return this.fb.group({
      // Define your form controls here based on the truck object
      truckType: [truck.truck, [Validators.required]],
      hourly: [0, Validators.pattern('^[0-9]+(.[0-9]+)?$')],
      nightly: [0],
      weekly: [0, Validators.pattern('^[0-9]+(.[0-9]+)?$')],
      daily: [
        truck.fareChargesDaily,
        [Validators.required, Validators.pattern('^[0-9]+(.[0-9]+)?$')],
      ],
      monthly: [
        Validators.required,
        truck.fareChargesMonthly,
        Validators.pattern('^[0-9]+(.[0-9]+)?$'),
      ],
      slot1: [truck.overStayChargesTimeSlot1],
      slot2: [truck.overStayChargesTimeSlot2],
      slot3: [truck.overStayChargesTimeSlot3],
      IsHourlyCharge: [truck.isHourlyCharge],
      IsDailyCharge: [truck.isDailyCharge],
      IsWeeklyCharge: [truck.isWeeklyCharge],
      IsMonthlyCharge: [truck.isMonthlyCharge],
    });
  }
  buildForm(): void {
    this.parkingForm = this.fb.group({
      name: ['', [Validators.required]],
      hazardousLoadRate: [
        '',
        [
          Validators.pattern('^[0-9]+(.[0-9]+)?$'),
          CustomValidator.validateLessThanHundred,
        ],
      ],
      isHazardousLoad: [this.disableForm],
      oneTimeInstructions: ['', Validators.required],
      recurringInstructions: ['', [Validators.required]],
      oneTimeAccessCode: ['', [Validators.minLength(2)]],
      monthlyAccessCode: ['', [Validators.minLength(2)]],
      termsAndConditionFilePath: [''],
      location: [''],
      offer: [
        '',
        [
          Validators.pattern('^[0-9]+(.[0-9]+)?$'),
          CustomValidator.validateLessThanHundred,
        ],
      ],
      taxAndFees: [
        '',
        [
          Validators.pattern('^[0-9]+(.[0-9]+)?$'),
          CustomValidator.validateLessThanHundred,
        ],
      ],
      specialRates: [this.specialRates],
      truckTypeArray: this.fb.array([]),
      parkingLotFacility: this.fb.array([]),
      parkingPhotos: [''],
      locAddress: ['', Validators.required],
      totalSlots: [''],
      thresholdValue: [],
      isParkAnywhere: [],
      parkingLayoutImg: [],
      startDate: [],
      startTime: [],
      endDate: [],
      endTime: [],
      isEntireParkingUnderMaintenance: [],
      isParkingLotLayoutDoc: [null],
      spaceUnderMaintenance: [0],
    });
    this.parkingForm
      .get('locAddress')
      .valueChanges.subscribe((location: string) => {
        
        if (!location) {
          const location: LocationInput =
            this.parkingForm.get('location')?.value;
          location.country = '';
          location.state = '';
          location.latitude = null;
          location.longitude = null;
          location.address = '';
          location.streetView = '';
          this.parkingForm.patchValue({ location: location });
          this.parkingForm.patchValue({ location: '' });
        }
      });
    this.parkingUpcomingForm = this.fb.group({
      name: ['', [Validators.required]],
      location: [''],
      locAddress: ['', Validators.required],
    });
    this.parkingUpcomingForm
      .get('locAddress')
      .valueChanges.subscribe((location: string) => {
        if (!location) {
          const location: LocationInput =
            this.parkingUpcomingForm.get('location')?.value;
          location.country = '';
          location.state = '';
          location.latitude = null;
          location.longitude = null;
          location.address = '';
          location.streetView = '';
          this.parkingUpcomingForm.patchValue({ location: location });
        }
      });
  }

  oneTimeLimitText(_event: any, editor: Editor, dataKey: string) {
    const quill = editor.getQuill(); // Get Quill editor instance
    const content = quill.getText(); // Get plain text (ignoring HTML tags)
    const contents = quill.getContents();
    const ops = contents.ops;

    let index = 0;

    ops.forEach(op => {
      if (op.insert && op.insert.image) {
        quill.deleteText(index, 1); // delete image
      } else if (typeof op.insert === 'string') {
        index += op.insert.length; // count text length to keep index updated
      } else {
        index += 1; // account for other inserts
      }
    });

    this.oneTimeEditorTextLimitError = false;
    this.oneTimeEditorSpaceError = false;

    if( content.length > 1) {
      const trimContent = content.trim();
      if (trimContent.length === 0) {
        this.oneTimeEditorSpaceError = true; // Content is empty or only spaces
        this.textLength[dataKey] = content.length - 1; // Prevent negative value
        this.parkingForm.get('oneTimeInstructions')?.setErrors({ required: true }); // Set 'required' error
      } 
      // Check if the content exceeds 1000 characters
      else if (content.length > 1001) {
        this.oneTimeEditorTextLimitError = true; // Exceeds 1000 characters
        this.parkingForm.get('oneTimeInstructions')?.setErrors(null); // Clear 'required' error if within length limit
        this.textLength[dataKey] = content.length-1;
      } 
      else {
        // Valid content (not empty and within character limit)
        this.textLength[dataKey] = content.length-1; // Store actual length
        this.parkingForm.get('oneTimeInstructions')?.setErrors(null); // Remove any previous errors
      }
    }else {
      this.textLength[dataKey] = 0;
      this.parkingForm.get('oneTimeInstructions')?.setErrors({ required: true }); // Clear 'required' error if within length limit

    }
    // Check if the content is empty or only spaces
    
  }

  recurringLimitText(_event: any, editor: Editor, dataKey: string) {
    const quill = editor.getQuill(); // Get Quill editor instance
    const content = quill.getText(); // Get plain text (ignoring HTML tags)
     const contents = quill.getContents();
    const ops = contents.ops;

    let index = 0;

    ops.forEach(op => {
      if (op.insert && op.insert.image) {
        quill.deleteText(index, 1); // delete image
      } else if (typeof op.insert === 'string') {
        index += op.insert.length; // count text length to keep index updated
      } else {
        index += 1; // account for other inserts
      }
    });
    // Reset all errors
    this.recurringEditorTextLimitError = false;
    this.recurringEditorSpaceError = false;

    if( content.length > 1) {
      const trimContent = content.trim();
      if (trimContent.length === 0) {
        this.recurringEditorSpaceError = true; // Content is empty or only spaces
        this.textLength[dataKey] = content.length - 1; // Prevent negative value
        this.parkingForm.get('recurringInstructions')?.setErrors({ required: true }); // Set 'required' error
      } 
      // Check if the content exceeds 1000 characters
      else if (content.length > 1001) {
        this.recurringEditorTextLimitError = true; // Exceeds 1000 characters
        this.parkingForm.get('recurringInstructions')?.setErrors(null); // Clear 'required' error if within length limit
        this.textLength[dataKey] = content.length-1;
      } 
      else {
        this.textLength[dataKey] = content.length-1; // Store actual length
        this.parkingForm.get('recurringInstructions')?.setErrors(null); // Remove any previous errors
      }
    }else {
      this.textLength[dataKey] = 0;
      this.parkingForm.get('recurringInstructions')?.setErrors({ required: true }); // Clear 'required' error if within length limit

    }
    
  }

  addNewTruckType(truckType: any): void {
    if (truckType.length > 0) {
      truckType.forEach((item: any) => {
        this.truckTypeArray.push(this.newTruckType(item));
      });
    } else {
      this.truckTypeArray.push(this.newTruckType({}));
    }
    this.selectTruckType();
  }
  generateUniqueNumber(): string {
    return 'UN' + Date.now().toString();
  }

  newTruckType(item): FormGroup {
    return this.fb.group({
      spotTypeId: [item.vehicleTypeId],
      spotType: [item.vehicleName],
      dailyRate: [
        item.fareChargesDaily,
        [Validators.required, CustomValidator.validateGreaterThanZero],
      ],
      monthlyRate: [
        item.fareChargesMonthly,
        [Validators.required, CustomValidator.validateGreaterThanZero],
      ],
    });
  }

  get truckTypeArray(): FormArray {
    return this.parkingForm.get('truckTypeArray') as FormArray;
  }

  isFieldInvalid(fieldName: string) {
    const control = this.parkingForm.get(fieldName);
    return control?.invalid && (control?.touched || control?.dirty);
  }
  selectTruckType() {
    const selectedTruckData = (
      this.parkingForm.get('truckTypeArray') as FormArray
    ).value;
    const disabledTruckIds = new Set();
    selectedTruckData.forEach((item: any) => {
      if (item.truckType) {
        item.truckType.forEach((data: any) => {
          disabledTruckIds.add(data);
        });
      }
    });

    this.truckTypes.forEach((truck: any) => {
      truck.disabled = disabledTruckIds.has(truck.id);
    });
  }

  addFacilityId(id: string) {
    const index = this.parkingLotFacility.indexOf(id);

    if (index !== -1) {
      // ID is in the array, so remove it
      this.parkingLotFacility.splice(index, 1);
    } else {
      // ID is not in the array, so add it
      this.parkingLotFacility.push(id);
    }
  }

  nextPage(data: FormGroup): void {
    this.updateRecurringInstructionsValidator();
    const oneTimeAccessCode = this.parkingForm.get('oneTimeAccessCode')?.value;
    const monthlyAccessCode = this.parkingForm.get('monthlyAccessCode')?.value;
    if (!oneTimeAccessCode && monthlyAccessCode) {
      this.parkingForm.patchValue({ oneTimeAccessCode: monthlyAccessCode });
    } else if (!monthlyAccessCode && oneTimeAccessCode) {
      this.parkingForm.patchValue({ monthlyAccessCode: oneTimeAccessCode });
    } else if (!oneTimeAccessCode && !monthlyAccessCode) {
      this.parkingForm.patchValue({ oneTimeAccessCode: '', monthlyAccessCode: '' });
    }
    let truckData: any[] = [];
    this.parkingForm  
    truckData.push(this.spotTypes);
    this.truckTypeArray.controls.forEach((truckTypeItem: any) => {
      const spotTypeId = truckTypeItem.value.spotTypeId;
      const dailyRate = truckTypeItem.value.dailyRate;
      const monthlyRate = truckTypeItem.value.monthlyRate;
      const matchingTruckData = truckData[0].find(
        (data: any) => data.vehicleTypeId === spotTypeId
      );
      if (matchingTruckData) {
        matchingTruckData.fareChargesDaily = +dailyRate;
        matchingTruckData.fareChargesMonthly = +monthlyRate;
      }
    });
    this.parkingForm.patchValue({
      specialRates: this.specialRates,
      truckTypeArray: this.truckTypeArray.value,
    });
    if (!this.parkingForm.valid) {
      CustomValidator.markFormGroupTouched(this.parkingForm);
      this.toastService.showToastMessage(
        'error',
        'Error',
        'Fill All Mandatory Fields'
      );
      return;
    }
    if ((this.oneTimeEditorSpaceError || this.oneTimeEditorTextLimitError) || (this.recurringEditorSpaceError || this.recurringEditorTextLimitError)) {
      this.toastService.showToastMessage(
        'error',
        'Error',
        'Fill All Mandatory Fields'
      );
      return
    }
    if (this.isParkingCapacityError) {
      return;
    }
    if (!this.parkingForm.get('location')?.value.address) {
      this.toastService.showToastMessage('error', 'Error', "Please enter a valid address or select one from the suggestions.")
    return;
    }
    const isEntireParkingUnderMaintenance =
      data.value.isEntireParkingUnderMaintenance;
    let spaceUnderMaintenance = data.value.spaceUnderMaintenance;

    if (isEntireParkingUnderMaintenance === '1' || spaceUnderMaintenance) {
      // If "yes" is selected, check for dates and times
      if (
        !data.value.startDate ||
        !data.value.endDate 
      ) {
        this.toastService.showToastMessage(
          'error',
          'Error',
          UNDER_MAINTANCE_ERROR
        );
        return;
      }
    } else {
      if (
        !(
          (data.value.startDate &&
            data.value.endDate &&
            data.value.startTime &&
            data.value.endTime) ||
          (!data.value.startDate &&
            !data.value.endDate &&
            !data.value.startTime &&
            !data.value.endTime)
        )
      ) {
        this.toastService.showToastMessage(
          'error',
          'Error',
          UNDER_MAINTANCE_ERROR
        );
        return;
      }

      //  If "no" is selected, enforce that at least one slot is selected
      if (
        data.value.startDate &&
        data.value.endDate &&
        data.value.startTime &&
        data.value.endTime &&
        this.selectedSlots.length === 0 &&
        this.isParkAnywhere == false
      ) {
        // Show toaster for selecting maintenance slots
        this.toastService.showToastMessage(
          'error',
          'Error',
          'Please select spots for maintenance'
        );
        return; // Stop further execution
      }
      if (
        data.value.startDate &&
        data.value.endDate &&
        data.value.startTime &&
        data.value.endTime &&
        spaceUnderMaintenance == 0 &&
        this.isParkAnywhere == true
      ) {
        this.isParkingCapacityError = true;
        return; // Stop further execution
      }
      if (
        this.selectedSlots.length > 0 &&
        (!data.value.startDate ||
          !data.value.endDate ||
          !data.value.startTime ||
          !data.value.endTime)
      ) {
        this.toastService.showToastMessage(
          'error',
          'Error',
          UNDER_MAINTANCE_ERROR
        );
        return;
      }
    }
    let start =data?.value?.startTime === null? null: CommonFunctions.formatDateTime(data?.value?.startDate,data?.value?.startTime);
    let end = data.value.endTime === null ? null: CommonFunctions.formatDateTime(data?.value?.endDate,data?.value?.endTime);  
    if (!(data.value.startDate && data.value.endDate) || start < end) {
      if (this.parkingForm.valid) {
        let parkingLotFacilityArray = data.get(
          'parkingLotFacility'
        ) as FormArray;
        this.parkingLotFacility.forEach((fac) => {
          parkingLotFacilityArray.value.push(fac);
        });
        data
          .get('isEntireParkingUnderMaintenance')
          ?.patchValue(isEntireParkingUnderMaintenance === '1' ? true : false);
          data.patchValue
            data.get('startDate')?.setValue((start));
            data.get('endDate')?.setValue((end));
        data.get('parkingPhotos')?.patchValue(this.images);
        this.encryptStorage.setItem('truckData', JSON.stringify(truckData));
        this.encryptStorage.setItem('parkingFirstPage', JSON.stringify(data.value));
        this.encryptStorage.setItem('comingSoon', JSON.stringify(this.comingSoon));

        const selectedMaintenance: string[] = [];
        this.selectedSlots.forEach((x: any) => {
          selectedMaintenance.push(x.slotName);
        });
        this.encryptStorage.setItem(
          'selectedSlotsMian',
          JSON.stringify(selectedMaintenance)
        );
        this.parkingSlots(this.id);
      } else {
        CustomValidator.markFormGroupTouched(this.parkingForm);
      }
    } else {
      this.toastService.showToastMessage(
        'error',
        'Error',
        UNDER_MAINTANCE_GREATERTIME
      );
    }
  }
  updateComingsoon(data: FormGroup): void {
    if (!this.parkingUpcomingForm.valid) {
      this.toastService.showToastMessage(
        'error',
        'Error',
        'Fill All Mandatory Fields'
      );
    } else {
      this.parkingService.deleteComingsoonParking(this.id)
       .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: (_res: any) => {
          this.createComingsoonParking(data);
        }
      });
    }
  }

  createComingsoonParking(data) {
    let editComingsoonParkingRequest: CreateComingSoonParking = {
      name: data.value.name,
      location: data.value.location,
    };
    
    this.parkingService
      .CreateComingSoonParking(editComingsoonParkingRequest)
      .pipe(
        autoUnsubWith(this.destroyRef)
      )
      .subscribe({
        next: () => {
          
          this.openSuccessModal();
        },
        error: (err: HttpErrorResponse) => {
          
          this.toastService.showToastMessage(
            'error',
            'Error',
            err.error.message
          );
        },
      });
  }
  openSuccessModal(): void {
    this.dialogControlService.openDialog(SuccessModalComponent, {
      width: '30%',
      data: {
        bodyText: MSG_UPDATE_PARKING,
      },
    });
  }

  openMap(
    form: FormGroup,
    addressControlName: string,
    locationControlName: string
  ) {
    this.dialogControlService.openDialog(MapsComponent, {
      width: '70%',
      data: form.get(locationControlName)?.value,
    });
    this.dialogControlService.onClose().subscribe((response: any) => {
      this.patchLocation(
        response,
        form,
        addressControlName,
        locationControlName
      );
    });
  }

  parkingSlots(id: string) {
    const rolePath = this.roleName === USER_ROLES.SUPER_ADMIN ? 'super-admin' : 'manager';
    this.router.navigateByUrl(`${rolePath}/parking/edit/slots/${id}`);
  }

  uploadImage1(event: any) {
    const formData = new FormData();
    const file = event.files[0];
    const maxSize = 5 * 1024 * 1024;
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    formData.append('Images', file, file.name);

    if (!fileExtension || !this.allowedExtensions.includes(fileExtension)) {
      this.toastService.showToastMessage(
        'error',
        'Error',
        Invalid_IMAGE_FORMAT
      );
      this.isImgError1 = false;
      this.fileUpload.clear();
      return false;
    } else if (
      file.size > maxSize &&
      (fileExtension || this.allowedExtensions.includes(fileExtension))
    ) {
      this.isImgError1 = true;
      this.fileUpload.clear();
      return false;
    } else {
      this.isImgError1 = false;
    }
    if (
      file.size < maxSize &&
      (fileExtension || this.allowedExtensions.includes(fileExtension))
    ) {
      
      this.parkingService
        .imageUplaod(formData)
        .pipe(
          autoUnsubWith(this.destroyRef))
        .subscribe((response) => {
          if (response) {
            const data = response;
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                const url = data[key];
                this.imageUrl1 = url;
                this.images.push(url);
                this.btn1 = true;
              }
            }
            
          }
        });
    }

    return true;
  }
  uploadImage2(event: any) {
    const formData = new FormData();
    const file = event.files[0];
    const maxSize = 5 * 1024 * 1024;
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    formData.append('Images', file, file.name);

    if (!fileExtension || !this.allowedExtensions.includes(fileExtension)) {
      this.toastService.showToastMessage(
        'error',
        'Error',
        Invalid_IMAGE_FORMAT
      );
      this.isImgError2 = false;
      this.fileUpload1.clear();
      return false;
    } else if (
      file.size > maxSize &&
      (fileExtension || this.allowedExtensions.includes(fileExtension))
    ) {
      this.isImgError2 = true;
      this.fileUpload1.clear();
      return false;
    } else {
      this.isImgError2 = false;
    }

    if (
      file.size < maxSize &&
      (fileExtension || this.allowedExtensions.includes(fileExtension))
    ) {
      
      this.parkingService
        .imageUplaod(formData)
        .pipe(
          autoUnsubWith(this.destroyRef))
        .subscribe((response) => {
          if (response) {
            const data = response;
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                const url = data[key];
                this.imageUrl2 = url;
                this.images.push(url);
                this.btn2 = true;
              }
            }
            
          }
        });
    }
    return true;
  }

  uploadImage3(event: any) {
    const formData = new FormData();
    const file = event.files[0];
    const maxSize = 5 * 1024 * 1024;
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    formData.append('Images', file, file.name);

    if (!fileExtension || !this.allowedExtensions.includes(fileExtension)) {
      this.toastService.showToastMessage(
        'error',
        'Error',
        Invalid_IMAGE_FORMAT
      );
      this.isImgError3 = false;
      this.fileUpload2.clear();
      return false;
    } else if (
      file.size > maxSize &&
      (fileExtension || this.allowedExtensions.includes(fileExtension))
    ) {
      this.isImgError3 = true;
      this.fileUpload2.clear();
      return false;
    } else {
      this.isImgError3 = false;
    }

    if (
      file.size < maxSize &&
      (fileExtension || this.allowedExtensions.includes(fileExtension))
    ) {
      
      this.parkingService
        .imageUplaod(formData)
        .pipe(
          autoUnsubWith(this.destroyRef))
        .subscribe((response) => {
          if (response) {
            const data = response;
            for (const key in data) {
              if (data.hasOwnProperty(key)) {
                const url = data[key];
                this.imageUrl3 = url;
                this.images.push(url);
                this.btn3 = true;
              }
            } 
          }
        });
    }
    return true;
  }

  fileSizeValidator(maxSize: number) {
    return (control: AbstractControl) => {
      if (control.value) {
        const file = control.value as File; // Cast control.value to File
        if (file.size > maxSize * 1024 * 1024) {
          // Convert maxSize to bytes
          return {
            fileSizeExceedsLimit: true,
          };
        }
      }
      return null;
    };
  }

  del1(event: string) {
    // Find the index of the URL in the array
    const index = this.images.indexOf(event);
    // Check if the URL is in the array
    if (index !== -1) {
      // Remove the URL from the array
      this.images.splice(index, 1);
      this.fileUpload.clear();
      this.imageUrl1 = '';
      this.btn1 = false;
    }

    // Verify that the URL has been removed
  }

  del2(event: string) {
    // Find the index of the URL in the array
    const index = this.images.indexOf(event);
    // Check if the URL is in the array
    if (index !== -1) {
      // Remove the URL from the array
      this.images.splice(index, 1);
      this.imageUrl2 = '';
      this.fileUpload1.clear();
      this.btn2 = false;
    }

    // Verify that the URL has been removed
  }

  del3(event: string) {
    // Find the index of the URL in the array
    const index = this.images.indexOf(event);
    // Check if the URL is in the array
    if (index !== -1) {
      // Remove the URL from the array
      this.images.splice(index, 1);
      this.imageUrl3 = '';
      this.btn3 = false;
      this.fileUpload2.clear();
    }
    // Verify that the URL has been removed
  }

  getFacilityControl(): FormControl {
    return this.parkingForm.get('fakeFacilities') as FormControl;
  }

  showDialog(imageLink: string): void {
    this.imagePreview = true;
    this.imageLinkForPreview = imageLink;
    this.visible = true;
  }
  onDialogHide(): void {
    this.visible = false;
  }
  entireParkingMaintance(value: string) {
    if (value == '1') {
      this.isEntireParkingNotAvaliable = true;
      this.parkingForm.controls['spaceUnderMaintenance'].disable();
      this.isParkingCapacityError = false;
      this.noSlotSelected = false;
      this.selectedSlots = [];
    } else {
      this.isEntireParkingNotAvaliable = false;
      this.parkingForm.controls['spaceUnderMaintenance'].enable();
      this.noSlotSelected = true;
    }
  }

  searchAutoCompleteLocation(location: any, formType: string) {
    if (formType === 'parking') {

      this.patchLocation(location, this.parkingForm, 'locAddress', 'location');
    } else if (formType === 'parkingUpcoming') {
       this.patchLocation(
        location,
        this.parkingUpcomingForm,
        'locAdress',
        'location'
      );
    }
  }

  patchLocation(
    location: any,
    form: FormGroup,
    addressControlName: string,
    locationControlName: string
  ): void {
    if (location) {
      const existing = form.get(locationControlName)?.value;
      const existingId =
        existing && typeof existing === 'object' ? existing.id : undefined;
      form.patchValue({
        [addressControlName]: location.address,
        [locationControlName]: { ...location, id: existingId },
      });
    }
  }
  deleteVehicle(event: Event, index: number): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: MSG_DELETE_VEHICLE,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.vehicleNamesArray.splice(index, 1);
        this.truckTypeArray.removeAt(index);
        this.totalTruckCategory -= 1;
        this.selectTruckType();
      },
    });
  }
  checkMaxSlots(event: Event) {
    const enteredValue = (event.target as HTMLInputElement).value.trim(); // Get the trimmed value
    const parsedValue = parseInt(enteredValue, 10); // Convert the value to an integer
    if (isNaN(parsedValue)) {
      return;
    }

    const totalNumberOfSlots = this.totalNumberOfSlots; // Assuming this is the total number of slots
    if (parsedValue > totalNumberOfSlots) {
      this.isParkingCapacityError = true;
    } else {
      this.isParkingCapacityError = false;
    }
  }

  getSelectedVehicleNames(index: number): string[] {
    return this.vehicleNamesArray[index].map((vehicle: any) => vehicle.name);
  }

  updateSelectedVehicleNames(index: number, selectedNames: string[]): void {
    const selectedVehicles = this.truckTypes.filter((vehicle: any) =>
      selectedNames.includes(vehicle.name)
    );
    this.vehicleNamesArray[index] = selectedVehicles;
  }
  toogleHazardousload() {
    this.disableForm = !this.disableForm;
  }
  onCkEditorReady(_editor: any): boolean {
    const result = true;
    return result;
  }

  comingsoonCheckbox(checked: boolean): void {
    this.isComingsoonParking = checked;
    if (!this.isComingsoonParking) {
      this.parkingForm.patchValue({
        name: this.parkingLotDetail.name,
        locAddress: this.parkingLotDetail.location.address,
        location: this.parkingLotDetail.location,
      });
    }
  }

  onKeyPressAllowTwoDigitAfterPoint(event: KeyboardEvent): void {
    if (!validateInput(event)) {
      event.preventDefault();
    }
  }
}
